import { render, staticRenderFns } from "./IconParent.vue?vue&type=template&id=4c2d707c&"
import script from "./IconParent.vue?vue&type=script&lang=js&"
export * from "./IconParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports